module.exports = __webpack_public_path__ + "img/longarrow-left-black.8747b7f9.svg";